import Alert from "components/Objects/Alert";
import BusinessCard from "components/Objects/BusinessCard";
import BulkAddTask from "components/Objects/BulkAddTask";
import Candidate from "components/Objects/Candidate"
import Copyable from "components/Objects/Copyable";
import Customer from "components/Objects/Customer";
import CustomerLocation from "components/Objects/CustomerLocation";
import DispatcherTracker from "components/Objects/DispatcherTracker";
import DispatchMap from "components/Objects/DispatchMap"
import EngineerInfo from "components/Objects/EngineerInfo";
import EngineerStats from "components/Objects/EngineerStats";
import FeedbackZone from "./FeedbackZone";
import FELocationMap from "./FELocationMap";
import FERadiusMap from "./FERadiusMap";
import Financial from "components/Objects/Financial";
import GradeComponent from "components/Objects/GradeComponent"
import HelpDeskAdd from "./HelpDeskAdd";
import HelpDesksContacted from "./HelpDesksContacted";
import HelpDeskDisplay from "./HelpDeskDisplay";
import HelpDeskRescheduleFourth from "./HelpDeskRescheduleFourth";
import Invoice from "./Invoice";
import IdleTask from "./IdleTask";
import HiringHeatmap from "./HiringHeatmap";
import PhoneLog from "components/Objects/PhoneLog";
import Region from "components/Objects/Region";
import Ticket from "components/Objects/Ticket";
import TicketCheckList from "components/Objects/TicketCheckList";
import TicketDetails from "components/Objects/TicketDetails"
import TicketNote from "components/Objects/TicketNote";
import TimeOffRequest from "components/Objects/TimeOffRequest";
import ScheduleFieldEngineer from "components/Objects/ScheduleFieldEngineer";
import ScheduleTicket from "components/Objects/ScheduleTicket";
import ScheduleMap from "components/Objects/ScheduleMap";
import ScheduleMapFE from "components/Objects/ScheduleMapFE";
import ScheduleMapRouting from "components/Objects/ScheduleMapRouting";
import SubRegion from "components/Objects/SubRegion";
import User from "components/Objects/User";
import Video from "components/Objects/Video";
import Category from "components/Objects/Category";
import SubCategory from "components/Objects/SubCategory";
import ManagerTask from "components/Objects/ManagerTask";
import ScorePart from "components/Objects/ScorePart";
import ImportList from "components/Objects/ImportList";
import StripeCharge from "components/Objects/StripeCharge";
import KpiMetric from "components/Objects/KpiMetric";
import HiringZonesMap from "components/Objects/HiringZonesMap";
import RemoteAppointments from "components/Objects/RemoteAppointments"
import MultiplePhoneLogs from "components/Objects/MultiplePhoneLogs"
import TripFees from "components/Objects/TripFees"
import RegionFeedback from "components/Objects/RegionFeedback"
import Refund from "components/Objects/Refund";
import OutstandingInvoice from "components/Objects/OutstandingInvoice";

//Forms
import CompletionCertificate from "components/Objects/CompletionCertificate";
import ComputerRepairWaiver from "components/Objects/ComputerRepairWaiver";
import MandatoryAntiVirusInspectionWaiver from "components/Objects/MandatoryAntiVirusInspectionWaiver";
import MandatoryDataBackupWaiver from "components/Objects/MandatoryDataBackupWaiver";
import MandatoryHardDriveInspectionWaiver from "components/Objects/MandatoryHardDriveInspectionWaiver";
import MandatoryNetworkInspectionWaiver from "components/Objects/MandatoryNetworkInspectionWaiver";
import RefundAgreement from "components/Objects/RefundAgreement";
import Signature from "components/Objects/Signature";
import CustomerCondensed from "./CustomerCondensed";


const Objects =  {
	Alert: Alert,
	BusinessCard: BusinessCard,
	BulkAddTask: BulkAddTask,
	Candidate: Candidate,
	Category: Category,
	Copyable: Copyable,
	CompletionCertificate: CompletionCertificate,
	ComputerRepairWaiver: ComputerRepairWaiver,
	Customer: Customer,
	CustomerCondensed: CustomerCondensed,
	CustomerLocation: CustomerLocation,
	DispatcherTracker: DispatcherTracker,
	DispatchMap: DispatchMap,
	EngineerInfo: EngineerInfo,
	EngineerStats: EngineerStats,
	FeedbackZone: FeedbackZone,
	FELocationMap: FELocationMap,
	FERadiusMap: FERadiusMap,
	Financial:Financial,
	GradeComponent: GradeComponent,
	HelpDeskAdd: HelpDeskAdd,
	HelpDesksContacted: HelpDesksContacted,
	HelpDeskDisplay: HelpDeskDisplay,
	HelpDeskRescheduleFourth: HelpDeskRescheduleFourth,
	HiringHeatmap: HiringHeatmap,
	HiringZonesMap: HiringZonesMap,
	ImportList: ImportList,
	Invoice: Invoice,
	IdleTask: IdleTask,
	KpiMetric: KpiMetric,
	PhoneLog: PhoneLog,
	OutstandingInvoice: OutstandingInvoice,
	ManagerTask: ManagerTask,
	MandatoryAntiVirusInspectionWaiver: MandatoryAntiVirusInspectionWaiver,
	MandatoryDataBackupWaiver: MandatoryDataBackupWaiver,
	MandatoryHardDriveInspectionWaiver: MandatoryHardDriveInspectionWaiver,
	MandatoryNetworkInspectionWaiver: MandatoryNetworkInspectionWaiver,
	MultiplePhoneLogs: MultiplePhoneLogs,
	Region: Region,
	RegionFeedback: RegionFeedback,
	Ticket: Ticket,
	TicketCheckList: TicketCheckList,
	TicketDetails: TicketDetails,
	TicketNote: TicketNote,
	Refund: Refund,
	RefundAgreement: RefundAgreement,
	RemoteAppointments: RemoteAppointments,
	ScheduleFieldEngineer: ScheduleFieldEngineer,
	ScheduleTicket: ScheduleTicket,
	ScheduleMap: ScheduleMap,
	ScheduleMapFE: ScheduleMapFE,
	ScheduleMapRouting: ScheduleMapRouting,
	ScorePart: ScorePart,
	StripeCharge: StripeCharge,
	TimeOffRequest: TimeOffRequest,
	TripFees: TripFees,
	User: User,
	Signature: Signature,
	SubCategory: SubCategory,
	SubRegion: SubRegion,
	Video: Video,
};

export default Objects;
